import React from 'react';

function EmptyState() {
  return <h3 className="empty-state text-muted">
    No tasks exist for this deal type and stage.
  </h3>;
}

export default EmptyState;